import { Currency } from '@/core/currency/interfaces';

const PKR: Currency = {
    name: 'Pakistani Rupee',
    demonym: 'Pakistani',
    majorSingle: 'Rupee',
    majorPlural: 'Rupees',
    codeNumeric: '586',
    symbol: 'Rs.',
    symbolNative: 'Rs',
    minorSingle: 'Paisa',
    minorPlural: 'Paise',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'PKR',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default PKR;
